import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Modal } from '@/components/custom/modal/modal';
import usePermission from '@/hooks/usePermission';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';

const INPUT_FORMAT = 'YYYY-MM-DDTHH:mm';
// Mesmo formato já usado em buildQuestionBookPayload ('published-at'): a API interpreta no fuso do servidor.
export const API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm';

/** Agendar não tem permissão própria: quem pode criar exercícios (ou é admin) pode agendar. */
export function useCanSchedulePublication() {
  const isAdmin = useCheckIncludeProfiles({ only: ['admin'] });
  const hasRole = usePermission('Criar exercícios', 'Questões e exercícios');
  return isAdmin || hasRole;
}

/** Exercício publicado cuja data de liberação ainda não chegou. */
export function isScheduledPublication(questionBook) {
  return Boolean(questionBook?.published && questionBook?.['published-at'] && moment(questionBook['published-at']).isAfter(moment()));
}

export function SchedulePublicationModal({ show, onClose, onConfirm, initialValue, title = 'Agendar publicação', confirmLabel = 'Agendar', isSubmitting = false }) {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!show) return;
    const initial = initialValue && moment(initialValue).isAfter(moment()) ? moment(initialValue) : moment().add(1, 'hour').startOf('hour');
    setValue(initial.format(INPUT_FORMAT));
  }, [show, initialValue]);

  const isValid = value && moment(value, INPUT_FORMAT).isAfter(moment());

  const handleSubmit = e => {
    e.preventDefault();
    if (isValid) onConfirm(moment(value, INPUT_FORMAT).format(API_DATETIME_FORMAT));
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
    >
      <form
        className="form"
        onSubmit={handleSubmit}
      >
        <h2 className="modal__simple-title">{title}</h2>
        <p className="mb-4">O exercício ficará visível para os alunos somente a partir da data e hora escolhidas.</p>

        <div className="form__row">
          <label
            className="form__label"
            htmlFor="schedule-published-at"
          >
            Data e hora de publicação
          </label>
          <input
            className="form__control"
            id="schedule-published-at"
            type="datetime-local"
            value={value}
            min={moment().format(INPUT_FORMAT)}
            onChange={e => setValue(e.target.value)}
          />
          {value && !isValid && <span style={{ color: 'red' }}>Escolha uma data futura</span>}
        </div>

        <button
          type="submit"
          className="btn btn--wide btn--primary"
          disabled={!isValid || isSubmitting}
        >
          {confirmLabel}
        </button>
      </form>
    </Modal>
  );
}
